import VideosGrid from "components/VideoGallary/VideosGrid/VideosGrid";
import React from "react";



export default function CustomerSays() {
  return (
    <>
    <VideosGrid isFromCustomer={true} />

    </>
    
    // <section className="our-testimonials section-spacing bg-gray">
    //   <div className="section-content text-center  container">
    //     <h2 className="section-title font-weight-semibold mb-30">
    //       See What Our Customers Say About Us
    //     </h2>
    //   </div>
    //   <div className="row testimonial-list justify-content-center">
    //     <div className="col-lg-4 col-md-4 col-sm-6">
    //       <div className="testimonials-item">
    //         <div className="testimonial-img">
    //           <img src={Testimonial1} alt="" className="img-fluid" />
    //           <div className="bg-overlay">
    //             <a href="#" className="play-icon" title="Play Video">
    //               <i className="fa-solid fa-play"></i>
    //             </a>
    //           </div>
    //         </div>
    //         <div className="testimonial-content">
    //           <h4 className="font-weight-semibold mb-xl-3 mb-2">Umrah Group</h4>
    //           <h6>
    //             Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
    //             tincidunt orci sit amet
    //           </h6>
    //         </div>
    //       </div>
    //     </div>
    //     <div className="col-lg-4 col-md-4 col-sm-6">
    //       <div className="testimonials-item">
    //         <div className="testimonial-img">
    //           <img src={Testimonial2} alt="" className="img-fluid" />
    //           <div className="bg-overlay">
    //             <a href="#" className="play-icon" title="Play Video">
    //               <i className="fa-solid fa-play"></i>
    //             </a>
    //           </div>
    //         </div>
    //         <div className="testimonial-content">
    //           <h4 className="font-weight-semibold mb-xl-3 mb-2">Hajj Review</h4>
    //           <h6>
    //             Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
    //             tincidunt orci sit amet
    //           </h6>
    //         </div>
    //       </div>
    //     </div>
    //     <div className="col-lg-4 col-md-4 col-sm-6">
    //       <div className="testimonials-item">
    //         <div className="testimonial-img">
    //           <img src={Testimonial3} alt="" className="img-fluid" />
    //           <div className="bg-overlay">
    //             <a href="#" className="play-icon" title="Play Video">
    //               <i className="fa-solid fa-play"></i>
    //             </a>
    //           </div>
    //         </div>
    //         <div className="testimonial-content">
    //           <h4 className="font-weight-semibold mb-xl-3 mb-2">
    //             Women’s Umrah Group
    //           </h4>
    //           <h6>
    //             Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
    //             tincidunt orci sit amet
    //           </h6>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </section>
  );
}
